//React Library
import React, { useState, useEffect } from "react";

//Material UI Styles
import { lighten, makeStyles, styled } from "@material-ui/core/styles";

//Material UI Components
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import Table from "@material-ui/core/Table";
import Container from "@material-ui/core/Container";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";


//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import refresh_token from "../../Global/refresh_token";
import Spinner from "../../Global/Spinner2";
import DarkButton from "../../Global/DarkButton";
import NoRecords from "../../Global/NoRecords";

//Custom Css + Images
import "./billing.css";
import swal from "@sweetalert/with-react";
import Delete from "../../Assets/delete.png";
import dots from "../../Assets/dots.png";
import download from  "../../Assets/download.png";
import dotsH from "../../Assets/dotsH.png";
import pencil from "../../Assets/pencil.png";
import pencilG from "../../Assets/pencilG.png";
import archive from "../../Assets/archive.png";
import archiveG from "../../Assets/archiveG.png";
import start from "../../Assets/start.png";
import startG from "../../Assets/startG.png";
import search from "../../Assets/search.png";
import file from "../../Assets/file.png";
import share from "../../Assets/share.png";
import timetable from "../../Assets/timetable.png";
import add from "../../Assets/add.png";
import filter from "../../Assets/Filter_Icon.png";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import CloseIcon from '@material-ui/icons/Close';

//React Router
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";

//Redux
import { addTeam } from "../../Redux/Actions/teamAction";
import { useSelector, useDispatch } from "react-redux";

//Others
import uuid from "react-uuid";
import {useTranslation} from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    maxHeight: "60vh",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

function BillingHistory() {
  const classes = useStyles();
  const {t} = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [tempLoader, setTempLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);

  let history = useHistory();



  useEffect(() => {
    getAllLicenses()
    }, [])
    
    
    const getAllLicenses = () => {
      setTempLoader(true)
      let localstorage = localStorage.getItem("UserData");
      var data = JSON.parse(localstorage);
      let token = data?.token;
    
      let params ={
        organization_id:data.organization_id
      }
    
      let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
      .join('&');
    
      fetch(GlobalApi + "/Package/get_organization_invoices?" + query, {
        method: 'GET',
        headers:{
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }
        
      })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if(response.msg === "success"){
          setTempLoader(false)
          setRows(response.invoices)
        }
      }).catch((error) => {
          console.log(error);
          setTempLoader(false)
        });
      }


  
  const headCells = [
    {
      id: "invoiceId",
      numeric: false,
      disablePadding: false,
      label: <>{t("Invoice ID")}</>,
      borderLeft: false,
      borderRight: true,
    },
    {
      id: "status",
      numeric: true,
      disablePadding: false,
      label: <>{t("Status")}</>,
      borderLeft: false,
      borderRight: true,
    },
        {
      id: "date",
      numeric: true,
      disablePadding: false,
      label: <>{t("Date")}</>,
      borderLeft: false,
      borderRight: true,
    },
    {
      id: "amount",
      numeric: true,
      disablePadding: false,
      label: <>{t("Amount")}</>,
      borderLeft: false,
      borderRight: true,
    },
    {
      id: "noOfLicense",
      numeric: true,
      disablePadding: false,
      label: <>{t("Number of License")}</>,
      borderLeft: false,
      borderRight: true,
    },
    {
      id: "currentStatus",
      numeric: true,
      disablePadding: false,
      label: <>{t("Currently Active")}</>,
      borderLeft: false,
      borderRight: true,
    },
    {
      id: "downloadInvoice",
      numeric: true,
      disablePadding: false,
      label: <>{t("Download Invoice")}</>,
      borderLeft: false,
      borderRight: language =="ar" ? true : false,
    },
  ];



  function EnhancedTableHead(props) {
    const {
      classes,
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {/* <TableCell padding="checkbox">
                  <Checkbox />
                </TableCell> */}
          {headCells.map((headCell, index) => (
            <TableCell
              style={{
                borderTop: "1px solid #dadada",
                borderLeft: headCell.borderLeft ? "1px solid #dadada" : "none",
                borderRight: headCell.borderRight
                  ? "1px solid #dadada"
                  : "none",
                padding: "7px",
                fontWeight: "bold",
                color: Colors.globalColor8,
                textTransform: "capitalize",
                backgroundColor:"#f2f2f2",
                textAlign:language =="ar" ? "right" : "left"
              }}
              key={headCell.id}
              align={"left"}
              padding={headCell.disablePadding ? "none" : "default"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {/* <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : "asc"}
                      onClick={createSortHandler(headCell.id)}
                    > */}
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
              {/* </TableSortLabel> */}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;

    return "";
  };

  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };






  return <Grid container justifyContent="center" alignItems="center" className="scrollHidden " style={{ backgroundColor: "white", padding: "5px 0px", borderRadius: "5px", marginTop: "0px", overflowY: "hidden", width: "100%" }}>
 
  <div style={{ padding: "0px 5px 5px ", width: "100%" }}>
    <div className="scrollbarShow2" style={{ overflow: "hidden", width: "100%" }}>
      {tempLoader && <div style={{ width: "100%", textAlign: "center", padding: 20 }}>
          <Spinner />
        </div>}
      {!tempLoader && <Grid container justifyContent="center" spacing={1} style={{ padding:window.innerWidth > 500 ? "20px" : "5px", height: "68vh" }}>
          {!tempLoader && rows?.length == 0 && <div style={{ padding: "20px", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
              <NoRecords />
            </div>}

          {!tempLoader && rows?.length !== 0 && <>
              {/* For Tablet and Desktop*/}
              {window.innerWidth > 500 && <TableContainer className={classes.container} >
                  <Table className="scrollHidden templateTable"  stickyHeader aria-label="sticky table" style={{ borderLeft: "1px solid #dadada", borderRight: "1px solid #dadada" }}>
                    <EnhancedTableHead classes={classes} numSelected={selected.length} order={order} orderBy={orderBy} rowCount={rows?.length} />
                    <TableBody classname="scrollHidden">
                      {rows?.length !== 0 ? rows?.sort((a,b) => a.status < b.status).map(
                          (row, index) => {
                                                        return <>
                                                            <TableRow hover tabIndex={-1} key={row.id} className="testingtable new-hover">
                                                              <TableCell component="th" scope="row" padding="none" style={{ padding: "3px 10px", minWidth: 200, borderRight: "1px solid #dadada",textAlign:language=="ar" ?"right" :"left" } // align="right"
                                                                }>
                                                                <>
                                                                  <Tooltip title={row?.invoiceNo}>
                                                                    <p style={{ margin: "3px  0px" }}>
                                                                      {row.invoice_id}
                                                                    </p>
                                                                  </Tooltip>
                                                                </>
                                                              </TableCell>
                                                              <TableCell style={{ padding: "3px 10px", textAlign: "center", borderRight: "1px solid #dadada" }}>
                                                                <p style={{ margin: "3px  0px" }}>
                                                                  {row.status}{" "}
                                                                </p>
                                                              </TableCell>
                                                              <TableCell style={{ padding: "3px 10px", textAlign: "center", borderRight: "1px solid #dadada" }}>
                                                                <p style={{ margin: "3px  0px" }}>
                                                                  {/* {moment(row.createdAt)} */}
                                                                  {moment(
                                                                    new Date(
                                                                      row?.createdAt
                                                                    )
                                                                  ).format(
                                                                    "DD/MM/YYYY"
                                                                  )}
                                                                </p>
                                                              </TableCell>
                                                              <TableCell style={{ padding: "3px 10px", textAlign: "center", borderRight: "1px solid #dadada" }}>
                                                                <p style={{ margin: "3px  0px" }}>
                                                                  {row?.amount}{" "}
                                                                  {row?.amount_type == "doller" ? "$" : "£"}
                                                                </p>
                                                              </TableCell>

                                                              <TableCell style={{ paddingTop: "2px", paddingBottom: "2px", textAlign: "center", borderRight: "1px solid #dadada" }}>
                                                                <p style={{ margin: "3px  0px" }}>
                                                                  {row?.no_of_licenses}
                                                                </p>
                                                              </TableCell>
                                                              <TableCell style={{ paddingTop: "2px", paddingBottom: "2px", textAlign: "center", borderRight: "1px solid #dadada" }}>
                                                                <p style={{ margin: "3px  0px", color:row?.currently_active=== "frozen" ? "red" : "green" }}>
                                                                  {row?.currently_active === "frozen" ? t("archived") : t("active")}
                                                                </p>
                                                              </TableCell>
                                                          

                                                              <TableCell style={{ padding: "2px 10px", textAlign: "center", verticalAlign: "middle",borderRight:language =="ar" && "1px solid #dadada" }}>
                                                                <img src={download} alt="open modal" style={{ cursor: "pointer" }} onClick={() => window.open(`https://server.uraudits.com/view?Key=${row?.pdf_url}`, "_blank")} width={20} />
                                                              </TableCell>
                                                            </TableRow>
                                                          </>;
                          }
                        ) : <TableRow>
                          <TableCell colSpan={6}>
                            <NoRecords />
                          </TableCell>
                        </TableRow>}
                    </TableBody>
                  </Table>
                </TableContainer>}

              {window.innerWidth <= 500 && <div className={classes.container} style={{overflowY:'scroll',width:'100%', padding:'5px'}} >
                  {rows?.length !== 0 && rows?.filter((v) => v?.name
                            ?.toLowerCase()
                            .includes(
                              searchText?.toLowerCase()
                            ) || v?.status
                            ?.toLowerCase()
                            .includes(
                              searchText?.toLowerCase()
                            ) || v?.scheduled
                            ?.toLowerCase()
                            .includes(
                              searchText?.toLowerCase()
                            )).map(
                      (row, index) => {
                        return <div className="hover shadow" style={{ display: "flex", justifyContent: "space-between", border: "1px solid #dadada", padding: "10px", margin: "5px", flexDirection: "row", alignItems: "center", textAlign: "left", height: "170px", borderRadius: "5px", backgroundColor: "white", overflow: "hidden" }}>
                            <div style={{ display: "flex", height: "100%", flexDirection: "column", justifyContent: "space-between" }}>
                              <div>
                                <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                                  Invoice Id
                                </p>
                                <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                                  {row.invoice_id}
                                </p>
                              </div>
                              <div>
                                <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                                  Date
                                </p>
                                <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                                  {moment(new Date(row?.createdAt)).format("DD/MM/YYYY")}
                                </p>
                              </div>
                              <div>
                                <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                                  Amount
                                </p>
                                <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                                  {row?.amount} {row?.amount_type == "doller" ? "$" : "£"}
                                </p>
                              </div>
                              <div>
                                <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                                  No of License
                                </p>
                                <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                                {row?.no_of_licenses}
                                </p>
                              </div>
                            </div>

                            <div style={{ display: "flex", height: "100%", flexDirection: "column", justifyContent: "space-around" }}>
                              <div>
                              {row?.currently_active !== "frozen"  && <div>
                                  <DoneAllIcon style={{ color: "green" }} />
                                </div>}

                              {row?.currently_active === "frozen" && <div>
                                  <CloseIcon style={{ color: "red" }} />
                                </div>}
                                </div>
                                <div>
                                <img src={download} alt="open modal" style={{ cursor: "pointer" }} onClick={() => window.open(`https://server.uraudits.com/view?Key=${row?.pdf_url}`, "_blank")} width={20} />
                                </div>
                            </div>
                          </div>;
                      }
                    )}
                </div>}
            </>}
        </Grid>}
    </div>
  </div>
</Grid>;
}

export default BillingHistory;
